import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="cosmic-loader">
        <div className="cosmic-rings">
          <div className="ring"></div>
          <div className="ring"></div>
          <div className="ring"></div>
        </div>
        <div className="loading-text">Initializing Editor...</div>
      </div>
    </div>
  );
};

export default LoadingScreen; 